import React from 'react';
import propTypes from 'prop-types';
export const AirportDelayIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      id="flight_x5F_delay"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect height={size} width={size - 5} x="275.267" y="88.6" />
      <rect height={size} width={size - 5} x="275.267" y="398.521" />
      <path d="M275.267,153.691c0,41.595,26.349,77.022,63.263,90.535c4.941,1.81,8.226,6.51,8.226,11.773  c0,5.264-3.284,9.964-8.226,11.773c-36.914,13.514-63.263,48.94-63.263,90.535v28.645h192.802v-28.645  c0-41.595-26.349-77.021-63.262-90.535c-4.942-1.81-8.227-6.51-8.227-11.773l0,0c0-5.263,3.284-9.964,8.227-11.773  c36.913-13.513,63.262-48.94,63.262-90.535v-28.646H275.267V153.691z M409.664,336.408c11.225,8.34,18.283,17.119,22.381,23.376  c2.444,3.733-0.238,8.68-4.699,8.68h-55.679H315.99c-4.462,0-7.145-4.946-4.7-8.68c4.099-6.257,11.156-15.036,22.381-23.376  C356.256,319.629,387.079,319.629,409.664,336.408z M323.026,182.783c0-4.471,3.625-8.096,8.096-8.096h81.091  c4.472,0,8.096,3.625,8.096,8.096v0.561c0,26.864-21.777,48.641-48.641,48.641c-26.864,0-48.642-21.777-48.642-48.641V182.783z" />
      <path d="M120.163,327.059c0.626,3.716,2.522,7.1,5.364,9.573l9.766,8.5c2.634,2.292,6.742,0.44,6.771-3.05l0.648-80.658  l54.695,39.518c12.482,9.02,29.231,9.416,42.128,0.997l21.069-13.753c2.393-1.563,2.836-4.888,0.936-7.022l-2.32-2.604  c-4.258-4.781-10.715-6.975-17.004-5.773l-24.087,4.596l-111.628-94.823c-10.876-9.24-24.659-14.656-38.93-14.453  c-4.538,0.064-9.292,0.666-14.012,2.104c-8.497,2.591-12.223,12.246-7.674,19.876c0.067,0.112,0.136,0.226,0.206,0.34  c0.896,1.457,2.104,2.713,3.49,3.715l54.861,39.637L120.163,327.059z" />
      <path d="M225.381,208.076l-70.578-7.74c-2.864-0.314-4.443,3.235-2.291,5.153l18.191,16.203c3.357,2.99,7.752,4.546,12.243,4.336  l58.536-2.751c2.84-0.638,3.624-4.313,1.292-6.055l-8.647-6.461C231.61,208.881,228.52,207.932,225.381,208.076z" />
    </svg>
  );
};
AirportDelayIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
AirportDelayIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
